import React, { useState } from 'react';
import { TbStarFilled, TbStar } from 'react-icons/tb';

const StarRatingInput = ({ onChange }) => {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);

    const handleClick = (value) => {
        setRating(value);
        if (onChange) onChange(value);
    };

    const handleMouseEnter = (value) => {
        setHoverRating(value);
    };

    const handleMouseLeave = () => {
        setHoverRating(0);
    };

    return (
        <div className="d-flex justify-content-center text-start">
            <div dir="ltr" className="d-flex">
                {[1, 2, 3, 4, 5].map((star) => (
                    <div
                        key={star}
                        onClick={() => handleClick(star)}
                        onMouseEnter={() => handleMouseEnter(star)}
                        onMouseLeave={handleMouseLeave}
                        className="me-1"
                        style={{ cursor: 'pointer' }}
                    >
                        {(hoverRating || rating) >= star ? (
                            <TbStarFilled className="text-warning" size={28} />
                        ) : (
                            <TbStar className="text-warning" size={28} />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StarRatingInput;
